import { render } from "./EditNickname.vue?vue&type=template&id=72a293c4&scoped=true"
import script from "./EditNickname.vue?vue&type=script&lang=js"
export * from "./EditNickname.vue?vue&type=script&lang=js"

import "./EditNickname.vue?vue&type=style&index=0&id=72a293c4&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a293c4"]])

export default __exports__